export const GalaxyHero = ({ totalApps }) => (
  <div
    className="relative overflow-hidden rounded-2xl"
    style={{
      background: "linear-gradient(135deg, #060a12 0%, #0c1a2e 50%, #0a1020 100%)",
      border: "1px solid rgba(52,211,153,0.12)",
    }}
  >
    <div className="relative z-10 px-5 md:px-8 py-8 md:py-10">
      <p className="text-[10px] font-bold text-emerald-500/70 uppercase tracking-[0.25em] mb-3">
        AI Apps Observatory
      </p>
      <h1 className="text-xl md:text-3xl font-bold text-white leading-tight max-w-2xl mb-3">
        {totalApps?.toLocaleString() || "66,000+"} software applications. What are they optimizing for?
      </h1>
      <p className="text-xs md:text-sm text-slate-400 leading-relaxed max-w-2xl mb-6">
        Mapping AI software across care, utility, creativity, and extraction. From chatbots to code generators,
        therapy apps to surveillance tools. Every app reveals a choice about what matters.
      </p>
      <div className="flex flex-wrap gap-2.5">
        <button
          onClick={() => document.getElementById("observatory-content")?.scrollIntoView({ behavior: "smooth" })}
          className="px-4 py-2 bg-emerald-500 hover:bg-emerald-600 text-white text-xs md:text-sm font-semibold rounded-lg transition-colors shadow-lg shadow-emerald-500/20"
          data-testid="cta-explore"
        >
          Explore the Data
        </button>
        <button
          onClick={() => window.dispatchEvent(new CustomEvent("navigate", { detail: "about" }))}
          className="px-4 py-2 bg-white/[0.05] hover:bg-white/[0.1] border border-white/[0.1] text-white text-xs md:text-sm font-medium rounded-lg transition-colors"
          data-testid="cta-manifesto"
        >
          About the Observatory
        </button>
      </div>
    </div>
  </div>
);

export default GalaxyHero;
